export const Constant = {
  DEFAULT_PERSPECTIVE: 1000,
  DEFAULT_ROTATION_Y_IN_RADIAN: 0,

  DEFAULT_DURATION_IN_MS: 500,
  DEFAULT_DELAY_IN_MS: 0,

  FINAL_ROTATION_Y_IN_RADIAN: 2 * Math.PI,
};
